import { useState } from 'react';
import { Modal } from './ui.jsx';
import { subscribe } from './lib/db';

// Profile fields collected for targeting future surveys — stored on the SEPARATE
// subscriber list (migration 0008), never linked to a participant's anonymous answers.
const FIELDS = [['dentistry', 'Dentistry'], ['medicine', 'Medicine'], ['nursing', 'Nursing'], ['pharmacy', 'Pharmacy'], ['allied', 'Allied health'], ['other', 'Other']];
const ROLES = [['student', 'Student'], ['intern', 'Intern / house surgeon'], ['pg', 'Postgraduate / resident'], ['faculty', 'Faculty / practitioner'], ['other', 'Other']];
const YEARS = ['1st', '2nd', '3rd', '4th', '5th'];
const EXP = [['<5', 'Less than 5 years'], ['5-10', '5–10 years'], ['>10', 'More than 10 years']];

function SubscribeModal({ source, onClose, onDone }) {
  const [email, setEmail] = useState('');
  const [field, setField] = useState('');
  const [role, setRole] = useState('');
  const [year, setYear] = useState('');
  const [exp, setExp] = useState('');
  const [state, setState] = useState('idle'); // idle | saving | err

  async function submit(e) {
    e.preventDefault();
    if (!email.trim()) return;
    setState('saving');
    try {
      await subscribe(email.trim(), source, {
        role: role || null, field: field || null,
        study_year: role === 'student' ? (year || null) : null,
        experience: role === 'faculty' ? (exp || null) : null,
      });
      onDone();
    } catch (err) { console.warn('subscribe failed', err); setState('err'); }
  }

  return (
    <Modal titleId="subTitle" onEscape={onClose}>
      <h2 id="subTitle">📩 Subscribe to future surveys</h2>
      <p className="muted small">Be invited to new KAP studies and receive updated guideline summaries. <b>This is separate from your anonymous responses — your email is never linked to your answers.</b></p>
      <form onSubmit={submit}>
        <label className="flabel">Email
          <input className="num" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
        </label>
        <label className="flabel">Field
          <select className="num" value={field} onChange={(e) => setField(e.target.value)}>
            <option value="">Select…</option>
            {FIELDS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </label>
        <label className="flabel">You are a…
          <select className="num" value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">Select…</option>
            {ROLES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </label>
        {role === 'student' && (
          <label className="flabel">Year of study
            <select className="num" value={year} onChange={(e) => setYear(e.target.value)}>
              <option value="">Select…</option>
              {YEARS.map((y) => <option key={y} value={y}>{y} year</option>)}
            </select>
          </label>
        )}
        {role === 'faculty' && (
          <label className="flabel">Years of experience
            <select className="num" value={exp} onChange={(e) => setExp(e.target.value)}>
              <option value="">Select…</option>
              {EXP.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </label>
        )}
        {state === 'err' && <p className="muted small" style={{ marginTop: 8 }}>Couldn’t save just now — please try again, or bookmark <b>kapstat.com</b>.</p>}
        <div className="btn-row">
          <button type="button" className="btn btn--ghost" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn--primary" disabled={state === 'saving' || !email.trim()}>{state === 'saving' ? 'Subscribing…' : 'Subscribe'}</button>
        </div>
      </form>
    </Modal>
  );
}

// "Subscribe now" prompt: a short reminder + a button that pops up the profile modal.
export function SubscribeCTA({ source, compact }) {
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);

  if (done) {
    return <p className="muted small">📩 You’re subscribed — we’ll invite you to new studies and send guideline updates. <i>(kept separate from your anonymous answers)</i></p>;
  }
  return (
    <div className="subscribe">
      <h3>📩 Get invited to future surveys</h3>
      <p className="muted small">{compact ? 'Want a heads-up on new studies and updated guidelines? ' : 'Subscribe to be invited to new KAP studies and receive updated guideline summaries. '}It’s kept separate from your anonymous answers.</p>
      <button className="btn btn--primary" onClick={() => setOpen(true)}>Subscribe now</button>
      {open && <SubscribeModal source={source} onClose={() => setOpen(false)} onDone={() => { setDone(true); setOpen(false); }} />}
    </div>
  );
}
